<template>
  <el-dialog :visible.sync="visible_v" title="员工评价表" width="1200px" @close="() => { $emit('cancel') }">
    <div ref=print>
      <h2 style="text-align: center;">项目员工综合考评表</h2>
      <el-descriptions :column="2" border class="margin-top" title="">
        <el-descriptions-item>
          <template slot="label">
            受评对象姓名
          </template>
          {{ model.employeeRealName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            身份证号
          </template>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            服务单位
          </template>
          {{ model.companyName }}-{{ model.deptName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            考评类目
          </template>
          {{ model.evaluationCategory }}
        </el-descriptions-item>
      </el-descriptions>
      <div style="border-left: 1px solid #EBEEF5;border-right: 1px solid #EBEEF5;padding: 2px;">
        <p>
          评分说明：此项目员工综合考评表适用于中智项目外包员工的各类考评，包括但不限于试用期转正、年度调薪、年终奖系数、优秀员工评比等。</p>
        <p>
          评分角度：从项目一级管理员、项目领导两个角度对员工进行打分（每项仅勾选1个分数，共计7项），员工通过填写自评表进行自我评价。</p>
        <p>评分标准：</p>
        <p>试用期评分：工作态度不得低于14分；工作能力不得低于18分；工作表现不得低于10分；总分不得低于65分。</p>
        <p>年度调薪评分：工作态度不得低于22分；工作能力不得低于31分；工作表现不得低于21分；总分不得低于85分。</p>
        <p>优秀员工评分：工作态度不得低于22分；工作能力不得低于31分；工作表现不得低于21分；总分不得低于95分。</p>
        <p>
          年度绩效考评系数：优秀95—100，系数1.3-1.5；良好85—94，系数1-1.2；称职75—84，系数0.8-1；一般待提高65-74以下，系数0.5-0.8；不称职64及以下，系数0.2-0.5。</p>
      </div>
      <el-table
        :data="tableData"
        :header-cell-style="headerStyle"
        :span-method="objectSpanMethod"
        border
        style="width: 100%">
        <el-table-column label="评价项目" prop="v1"></el-table-column>
        <el-table-column label="评价项目" prop="v2"></el-table-column>
        <el-table-column label="评价项目" prop="v3" width="300"></el-table-column>
        <el-table-column label="对评价期间工作成绩的评价要点" prop="v4" width="450"></el-table-column>
        <el-table-column label="勾选（仅一项）" prop="v5" width="60"></el-table-column>
        <el-table-column label="勾选（仅一项）" prop="v6" width="80">
          <template slot-scope="scope">
            <el-radio v-if="scope.$index == 0" v-model="radio" :label="10" @input="inputRadio">10分</el-radio>
            <el-radio v-if="scope.$index == 1" v-model="radio" :label="8" @input="inputRadio">8分</el-radio>
            <el-radio v-if="scope.$index == 2" v-model="radio" :label="6" @input="inputRadio">6分</el-radio>
            <el-radio v-if="scope.$index == 3" v-model="radio" :label="4" @input="inputRadio">4分</el-radio>
            <el-radio v-if="scope.$index == 4" v-model="radio" :label="2" @input="inputRadio">2分</el-radio>
            <el-radio v-if="scope.$index == 5" v-model="radio2" :label="10" @input="inputRadio">10分</el-radio>
            <el-radio v-if="scope.$index == 6" v-model="radio2" :label="8" @input="inputRadio">8分</el-radio>
            <el-radio v-if="scope.$index == 7" v-model="radio2" :label="4" @input="inputRadio">4分</el-radio>
            <el-radio v-if="scope.$index == 8" v-model="radio2" :label="2" @input="inputRadio">2分</el-radio>
            <el-radio v-if="scope.$index == 9" v-model="radio3" :label="10" @input="inputRadio">10分</el-radio>
            <el-radio v-if="scope.$index == 10" v-model="radio3" :label="8" @input="inputRadio">8分</el-radio>
            <el-radio v-if="scope.$index == 11" v-model="radio3" :label="6" @input="inputRadio">6分</el-radio>
            <el-radio v-if="scope.$index == 12" v-model="radio3" :label="4" @input="inputRadio">4分</el-radio>
            <el-radio v-if="scope.$index == 13" v-model="radio4" :label="20" @input="inputRadio">20分</el-radio>
            <el-radio v-if="scope.$index == 14" v-model="radio4" :label="15" @input="inputRadio">15分</el-radio>
            <el-radio v-if="scope.$index == 15" v-model="radio4" :label="10" @input="inputRadio">10分</el-radio>
            <el-radio v-if="scope.$index == 16" v-model="radio4" :label="5" @input="inputRadio">5分</el-radio>
            <el-radio v-if="scope.$index == 17" v-model="radio5" :label="20" @input="inputRadio">20分</el-radio>
            <el-radio v-if="scope.$index == 18" v-model="radio5" :label="16" @input="inputRadio">16分</el-radio>
            <el-radio v-if="scope.$index == 19" v-model="radio5" :label="12" @input="inputRadio">12分</el-radio>
            <el-radio v-if="scope.$index == 20" v-model="radio5" :label="8" @input="inputRadio">8分</el-radio>
            <el-radio v-if="scope.$index == 21" v-model="radio5" :label="4" @input="inputRadio">4分</el-radio>
            <el-radio v-if="scope.$index == 22" v-model="radio6" :label="15" @input="inputRadio">15分</el-radio>
            <el-radio v-if="scope.$index == 23" v-model="radio6" :label="12" @input="inputRadio">12分</el-radio>
            <el-radio v-if="scope.$index == 24" v-model="radio6" :label="10" @input="inputRadio">10分</el-radio>
            <el-radio v-if="scope.$index == 25" v-model="radio6" :label="8" @input="inputRadio">8分</el-radio>
            <el-radio v-if="scope.$index == 26" v-model="radio6" :label="5" @input="inputRadio">5分</el-radio>
            <el-radio v-if="scope.$index == 27" v-model="radio7" :label="15" @input="inputRadio">15分</el-radio>
            <el-radio v-if="scope.$index == 28" v-model="radio7" :label="10" @input="inputRadio">10分</el-radio>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <p style="margin-top: 10px;">1.通过以上各项的评分，员工 {{ model.employeeRealName }} 的综合得分是
          {{ radio + radio2 + radio3 + radio4 + radio5 + radio6 + radio7 }} 分</p>
        <p style="margin-top: 10px;">2.考评等级为</p>
        <el-radio-group v-model="radios">
          <el-radio :disabled="radios != 0" :label="0">A优秀（95-100分）-需提供2个优秀事例</el-radio>
          <el-radio :disabled="radios != 1" :label="1">B良好（85-94分）-需提供1个优秀事例</el-radio>
          <el-radio :disabled="radios != 2" :label="2">C称职（75-84分）</el-radio>
          <el-radio :disabled="radios != 3" :label="3">D待提高 （65-75分）-需提供1个待改进事宜</el-radio>
          <el-radio :disabled="radios != 4" :label="4">E不合格（64及以下）-需提供2个待改进事宜</el-radio>
        </el-radio-group>
        <p v-if="radios !=2" style="margin-top: 10px;">
          评语：
          <span v-if="radios == 0 || radios == 1">优秀事例</span>
          <span v-if="radios == 3 || radios == 4">待改进事宜</span>
        </p>
        <el-input
          v-if="radios != 2"
          v-model="textarea"
          :placeholder="(radios == 0 || radios == 1) ? '请输入优秀事例(1)' : '请输入待改进事宜(1)'"
          :rows="5"
          type="textarea">
        </el-input>
        <el-input
          v-if="radios == 0 || radios == 4"
          v-model="textarea2"
          :placeholder="radios == 0 ? '请输入优秀事例(2)' :'请输入待改进事宜(2)'"
          :rows="5"
          type="textarea">
        </el-input>
        <el-row style="margin-top: 20px;">
          <el-col :span="12">
            <p>评价单位：</p>
          </el-col>
          <el-col :span="12">
            <p>受评对象签字：</p>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px;">
          <el-col :span="12">
            <p>日期：</p>
          </el-col>
          <el-col :span="12">
            <p>日期：</p>
          </el-col>
        </el-row>
      </div>
    </div>
    <div style="margin-top: 20px;">
      <Button :loading="addloading" style="margin-left: 450px;" type="primary" @click="auditclick">提交</Button>
      <Button style="margin-left: 100px;" type="primary" @click="goprint">打印</Button>
    </div>
  </el-dialog>
</template>
<script>
import permissionList from "@/libs/handlePermission.ts";
import {companyEvaluationEmployeeRecordPut,} from "@/api/evaluation";

export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  watch: {
    visible(v) {
      console.log(v)
      this.visible_v = v
      if (v) {
        this.init()
      }
    }
  },
  name: "company",
  data() {
    return {
      addloading: false,
      textarea: '',
      textarea2: '',
      radios: 0,
      radio: 10,
      radio2: 10,
      radio3: 10,
      radio4: 20,
      radio5: 20,
      radio6: 15,
      radio7: 15,
      formCustom: {
        checkList: ['站长']
      },
      visible_v: false,
      BaseUrl: process.env.VUE_APP_BASE_URL,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("getToken"),
      },
      tableData: [{
        v1: '工作态度30分',
        v2: '责任心10分',
        v3: '主动工作和承担责任的态度',
        v4: '1.工作非常主动，尽职尽责，公而忘私，用于承担责任',
        v5: '10分',
        v6: ''
      }, {
        v1: '',
        v2: '',
        v3: '',
        v4: '2.工作比较主动，责任心较强，能够承担责任',
        v5: '8分',
        v6: ''
      }, {
        v1: '',
        v2: '',
        v3: '',
        v4: '3.工作主动性一般，有一定责任感，基本上能承担责任',
        v5: '6分',
        v6: ''
      }, {
        v1: '',
        v2: '',
        v3: '',
        v4: '4.工作不够主动，有一定本位主义，偶有推卸责任',
        v5: '4分',
        v6: ''
      }, {
        v1: '工作态度30分',
        v2: '责任心10分',
        v3: '主动工作和承担责任的态度',
        v4: '5.工作很不主动,经常斤斤计较,经常推卸责任',
        v5: '2分',
        v6: ''
      }, {
        v1: '工作态度30分',
        v2: '勤勉性10分',
        v3: '遵守规章制度及劳动纪律、服从公司安排',
        v4: '1.严格遵守规章制度及劳动纪律，积极配合并支持公司各项安排',
        v5: '10分',
        v6: ''
      }, {
        v1: '工作态度30分',
        v2: '勤勉性10分',
        v3: '遵守规章制度及劳动纪律、服从公司安排',
        v4: '2.能较好遵守规章制度及劳动纪律，能服从公司安排',
        v5: '8分',
        v6: ''
      }, {
        v1: '工作态度30分',
        v2: '勤勉性10分',
        v3: '遵守规章制度及劳动纪律、服从公司安排',
        v4: '3.偶尔有违反规章制度或违纪现象，反对公司的部分工作安排',
        v5: '4分',
        v6: ''
      }, {
        v1: '工作态度30分',
        v2: '勤勉性10分',
        v3: '遵守规章制度及劳动纪律、服从公司安排',
        v4: '4.严重违反规章制度或劳动纪律，拒不服从公司各项安排',
        v5: '2分',
        v6: ''
      }, {
        v1: '工作态度30分',
        v2: '爱岗敬业10分',
        v3: '主要突出在服务意识方面',
        v4: '1.爱岗敬业，诚实守信，服务水平高，有奉献精神',
        v5: '10分',
        v6: ''
      }, {
        v1: '工作态度30分',
        v2: '爱岗敬业10分',
        v3: '主要突出在服务意识方面',
        v4: '2.有良好的岗位操守，服务水平较好',
        v5: '8分',
        v6: ''
      }, {
        v1: '工作态度30分',
        v2: '爱岗敬业10分',
        v3: '主要突出在服务意识方面',
        v4: '3.能遵守岗位操守，没有违反职业道德的行为',
        v5: '6分',
        v6: ''
      }, {
        v1: '工作态度30分',
        v2: '爱岗敬业10分',
        v3: '主要突出在服务意识方面',
        v4: '4.违反岗位操守，影响企业形象',
        v5: '4分',
        v6: ''
      }, {
        v1: '工作能力40分',
        v2: '工作成果20分',
        v3: '工作任务完成情况',
        v4: '1.工作业绩突出，能够高效完成各项任务',
        v5: '20分',
        v6: ''
      }, {
        v1: '工作能力40分',
        v2: '工作成果20分',
        v3: '工作任务完成情况',
        v4: '2.工作业绩较好，能够完成工作任务',
        v5: '15分',
        v6: ''
      }, {
        v1: '工作能力40分',
        v2: '工作成果20分',
        v3: '工作任务完成情况',
        v4: '3.工作业绩一般，基本能完成任务，但无突出表现或完成时间过长',
        v5: '10分',
        v6: ''
      }, {
        v1: '工作能力40分',
        v2: '工作成果20分',
        v3: '工作任务完成情况',
        v4: '4．无法按时完成工作任务，或履责有困难',
        v5: '5分',
        v6: ''
      }, {
        v1: '工作能力40分',
        v2: '工作质量20分',
        v3: '完成工作规定之标准及准确性',
        v4: '1.工作完成质量高，树立业务典型、模板作用',
        v5: '20分',
        v6: ''
      }, {
        v1: '工作能力40分',
        v2: '工作质量20分',
        v3: '完成工作规定之标准及准确性',
        v4: '2.无差错，工作准确、无失误，没有返工现象',
        v5: '16分',
        v6: ''
      }, {
        v1: '工作能力40分',
        v2: '工作质量20分',
        v3: '完成工作规定之标准及准确性',
        v4: '3.绝少差错、投诉，工作比较可靠，基本达到工作要求',
        v5: '12分',
        v6: ''
      }, {
        v1: '工作能力40分',
        v2: '工作质量20分',
        v3: '完成工作规定之标准及准确性',
        v4: '4.工作偶尔不到位，工作质量不太稳定，偶尔存在返工现象',
        v5: '8分',
        v6: ''
      }, {
        v1: '工作能力40分',
        v2: '工作质量20分',
        v3: '完成工作规定之标准及准确性',
        v4: '5.无法达到最低要求，工作常有错误或返工',
        v5: '4分',
        v6: ''
      }, {
        v1: '工作表现30分',
        v2: '客户满意度15分',
        v3: '提供的项目服务认可度',
        v4: '1.提供的服务完全达标，多次获得项目主管及客户单位好评或表扬',
        v5: '15分',
        v6: ''
      }, {
        v1: '工作表现30分',
        v2: '客户满意度15分',
        v3: '提供的项目服务认可度',
        v4: '2.提供的服务能够达标，项目主管及客户单位较为满意',
        v5: '12分',
        v6: ''
      }, {
        v1: '工作表现30分',
        v2: '客户满意度15分',
        v3: '提供的项目服务认可度',
        v4: '3.提供的服务基本合格，项目主管及客户单位基本认可工作表现',
        v5: '10分',
        v6: ''
      }, {
        v1: '工作表现30分',
        v2: '客户满意度15分',
        v3: '提供的项目服务认可度',
        v4: '4.提供的服务偶尔不达标，项目主管及客户单位提出过整改要求',
        v5: '8分',
        v6: ''
      }, {
        v1: '工作表现30分',
        v2: '客户满意度15分',
        v3: '提供的项目服务认可度',
        v4: '5.无法提供符合要求的服务，引起项目主管及客户单位严重不满',
        v5: '5分',
        v6: ''
      }, {
        v1: '工作表现30分',
        v2: '部门认可度15分',
        v3: '工作表现及贡献情况',
        v4: '1.整体工作表现优秀，对部门贡献大，获得部门主管及同事的认可',
        v5: '15分',
        v6: ''
      }, {
        v1: '工作表现30分',
        v2: '部门认可度15分',
        v3: '工作表现及贡献情况',
        v4: '2.整体工作表现良好，对部门有贡献，部门主管及同事均较为认可',
        v5: '10分',
        v6: ''
      }]
    }
  },
  components: {},
  mounted() {
    const list = JSON.parse(localStorage.getItem("routerList"))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    let token = localStorage.getItem('getToken')
    let userString = decodeURIComponent((window.atob(token.split('.')[1].replace(/-/g, "+").replace(/_/g, "/"))))
    let user = JSON.parse(userString);
    this.roleType = user.roleType;
  },
  methods: {
    init() {
      if (this.model.improvementMatter) {
        this.textarea = this.model.improvementMatter
      } else {
        this.textarea = ''
      }
      if (this.model.improvementMatterOther) {
        this.textarea2 = this.model.improvementMatter
      } else {
        this.textarea2 = ''
      }
      if (this.model.excellentExample) {
        this.textarea = this.model.improvementMatter
      } else {
        this.textarea = ''
      }
      if (this.model.excellentExampleOther) {
        this.textarea2 = this.model.improvementMatter
      } else {
        this.textarea2 = ''
      }
      if (this.model.employeeEvaluationItemScore) {
        this.radio = this.model.employeeEvaluationItemScore.split(',')[0] * 1
        this.radio2 = this.model.employeeEvaluationItemScore.split(',')[1] * 1
        this.radio3 = this.model.employeeEvaluationItemScore.split(',')[2] * 1
        this.radio4 = this.model.employeeEvaluationItemScore.split(',')[3] * 1
        this.radio5 = this.model.employeeEvaluationItemScore.split(',')[4] * 1
        this.radio6 = this.model.employeeEvaluationItemScore.split(',')[5] * 1
        this.radio7 = this.model.employeeEvaluationItemScore.split(',')[6] * 1
        this.inputRadio()
      } else {
        this.radio = 10
        this.radio2 = 10
        this.radio3 = 10
        this.radio4 = 20
        this.radio5 = 20
        this.radio6 = 15
        this.radio7 = 15
        this.inputRadio()
      }
    },
    goprint() {
      this.$print(this.$refs.print)
    },
    inputRadio() {
      const val = this.radio + this.radio2 + this.radio3 +
        this.radio4 + this.radio5 + this.radio6 + this.radio7;
      if (val >= 95) {
        this.radios = 0
      } else if (val >= 85) {
        this.radios = 1
      } else if (val >= 75) {
        this.radios = 2
      } else if (val >= 65) {
        this.radios = 3
      } else if (val < 65) {
        this.radios = 4
      }
    },
    headerStyle({row, column, rowIndex, columnIndex}) {
      row[1].colSpan = 3 //第二个表头占两格
      row[5].colSpan = 2 //第二个表头占两格
      row[0].colSpan = 0 //第一个表头占零格
      row[2].colSpan = 0 //第一个表头占零格
      row[4].colSpan = 0 //第一个表头占零格
      if (columnIndex === 0 || columnIndex === 2 || columnIndex === 4) { //隐藏第一个表头
        return 'display: none'
      }
    },
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 2) {
        if (rowIndex == 0) {
          return {
            rowspan: 5,
            colspan: 1
          };
        }
        if (rowIndex == 5) {
          return {
            rowspan: 4,
            colspan: 1
          };
        }
        if (rowIndex == 9) {
          return {
            rowspan: 4,
            colspan: 1
          };
        }
        if (rowIndex == 13) {
          return {
            rowspan: 4,
            colspan: 1
          };
        }
        if (rowIndex == 17) {
          return {
            rowspan: 5,
            colspan: 1
          };
        }
        if (rowIndex == 22) {
          return {
            rowspan: 5,
            colspan: 1
          };
        }
        if (rowIndex == 27) {
          return {
            rowspan: 5,
            colspan: 1
          };
        }
        if (rowIndex == 29) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 1) {
        if (rowIndex == 0) {
          return {
            rowspan: 5,
            colspan: 1
          };
        }
        if (rowIndex == 5) {
          return {
            rowspan: 4,
            colspan: 1
          };
        }
        if (rowIndex == 9) {
          return {
            rowspan: 4,
            colspan: 1
          };
        }
        if (rowIndex == 13) {
          return {
            rowspan: 4,
            colspan: 1
          };
        }
        if (rowIndex == 17) {
          return {
            rowspan: 5,
            colspan: 1
          };
        }
        if (rowIndex == 22) {
          return {
            rowspan: 5,
            colspan: 1
          };
        }
        if (rowIndex == 27) {
          return {
            rowspan: 5,
            colspan: 1
          };
        }
        if (rowIndex == 29) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 0) {
        if (rowIndex == 0) {
          return {
            rowspan: 13,
            colspan: 1
          };
        }
        if (rowIndex == 13) {
          return {
            rowspan: 9,
            colspan: 1
          };
        }
        if (rowIndex == 22) {
          return {
            rowspan: 7,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    addAbsenteeism() {

    },
    handleSuccess(response, file, fileList) {
      this.$Message.success("导入成功");
    },
    // 导入失败
    handleError(err, file) {
      if (err) {
        const erro = JSON.parse(err.message);
        if (erro.code === "100050") {
          this.$alert("导入失败", "提示", {
            confirmButtonText: "确定",
          });
        } else {
          this.$alert(erro.msg, "提示", {
            confirmButtonText: "确定",
          });
        }
      }
    },
    auditclick() {
      const params = {
        companyEvaluationEmployeeRecordId: this.model.companyEvaluationEmployeeRecordId,
        employeeEvaluationItemScore: this.radio + ',' + this.radio2 + ',' + this.radio3 + ',' + this.radio4 + ',' + this.radio5 + ',' + this.radio6 + ',' + this.radio7,
      };
      if (this.radios == 0) {
        if (!this.textarea || !this.textarea2) {
          this.$message.error('请先填写2个优秀事例')
          return
        } else {
          params.excellentExample = this.textarea
          params.excellentExampleOther = this.textarea2
        }
      } else if (this.radios == 1) {
        if (!this.textarea) {
          this.$message.error('请先填写优秀事例')
          return
        } else {
          params.excellentExample = this.textarea
        }
      } else if (this.radios == 3) {
        if (!this.textarea) {
          this.$message.error('请先填写待改进事宜')
          return
        } else {
          params.improvementMatter = this.textarea
        }
      } else if (this.radios == 4) {
        if (!this.textarea || !this.textarea2) {
          this.$message.error('请先填写2个待改进事宜')
          return
        } else {
          params.improvementMatter = this.textarea
          params.improvementMatterOther = this.textarea2
        }
      }
      companyEvaluationEmployeeRecordPut(params).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg)
          this.$emit('save')
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(error => {
        this.$message.error(error.response.data.msg)
      })
    },
  }
}
</script>
